import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login";
import index from "@/components/index";
import detail from "@/components/detailsque";
import viewsGroup from "@/components/viewsGroup";
import addexam from "@/components/examView/addexam";
import sign from "@/components/examView/sign";
import mcq from "@/components/examView/mcq";
import tfai from "@/components/examView/tfai";
import exercise from "@/components/examView/exercise";
import questions from "@/components/examView/questions";
import questionnaire from "@/components/questionnaire/questionnaire";
import task from "@/components/task/task";
import monitor from "@/components/task/monitor";
import peomonitor from "@/components/task/peomonitor";
import addtask from "@/components/task/addtask";
import analysis from "@/components/task/analysis";
import makeup from "@/components/task/makeup";
import examView from "@/components/task/examView";
import examrecord from "@/components/task/examRecord";
import userindex from "@/components/user/index";
import userknow from "@/components/user/userknow";
import useranswer from "@/components/user/useranswer";
import userVideo from "@/components/user/userVideo";
import addpaper from "@/components/task/addpaper";
import addlearning from "@/components/questionnaire/addlearning";
import questionIndex from "@/components/questionnaire/index";
import recycle from "@/components/recycle/";
import manager from "@/components/manager/manager";
import test from "@/components/test/test";
import bmgl from "@/components/manager/bmgl";
import ccss from "@/components/user/ccss";
import external from "@/components/scholl/external/external";
import previewTest from "@/components/scholl/previewTest/previewTest";
import examTest from "@/components/scholl/examTest/examTest";
import parseTest from "@/components/scholl/parseTest/parseTest";
import cursewareExam from "@/components/courseware-exam/curseware-exam.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/",
      name: "index",
      component: index
    },
    {
      path: "/ccss",
      name: "ccss",
      component: ccss
    },
    {
      path: "/detail",
      name: "detail",
      component: detail
    },
    {
      path: "/viewsGroup",
      name: "viewsGroup",
      component: viewsGroup
    },
    {
      path: "/addexam",
      name: "addexam",
      component: addexam,
      children: [
        { name: "sign", path: "sign", component: sign },
        { name: "mcq", path: "mcq", component: mcq },
        { name: "tfai", path: "tfai", component: tfai },
        { name: "exercise", path: "exercise", component: exercise },
        { name: "questions", path: "questions", component: questions }
      ]
    },
    {
      path: "/questionnaire",
      name: "questionnaire",
      component: questionnaire
    },
    {
      path: "/task",
      name: "task",
      component: task
    },
    {
      path: "/recycle",
      name: "recycle",
      component: recycle
    },
    {
      path: "/monitor",
      name: "monitor",
      component: monitor,
      children: [
        { name: "peomonitor", path: "peomonitor", component: peomonitor },
        { name: "analysis", path: "analysis", component: analysis },
        { name: "makeup", path: "makeup", component: makeup }
      ]
    },
    {
      path: "/addtask",
      name: "addtask",
      component: addtask
    },
    {
      path: "/examView",
      name: "examView",
      component: examView
    },
    {
      path: "/examrecord",
      name: "examrecord",
      component: examrecord
    },
    {
      path: "/userindex",
      name: "userindex",
      component: userindex
    },
    {
      path: "/userknow",
      name: "userknow",
      component: userknow
    },
    {
      path: "/addpaper",
      name: "addpaper",
      component: addpaper
    },
    {
      path: "/useranswer",
      name: "useranswer",
      component: useranswer
    },
    {
      path: "/addlearning",
      name: "addlearning",
      component: addlearning
    },
    {
      path: "/questionIndex",
      name: "questionIndex",
      component: questionIndex
    },
    {
      path: "/userVideo",
      name: "userVideo",
      component: userVideo
    },
    {
      path: "/test",
      name: "test",
      component: test
    },
    {
      path: "/manager",
      name: "manager",
      component: manager
    },
    {
      path: "/bmgl",
      name: "bmgl",
      component: bmgl
    },
    /*学堂部分*/
    {
      path: "/cursewareExam",
      name: "cursewareExam",
      component: cursewareExam
    },
    {
      path: "/external",
      name: "external",
      component: external
    },
    {
      path: "/previewTest",
      name: "previewTest",
      component: previewTest
    },
    {
      path: "/examTest",
      name: "examTest",
      component: examTest
    },
    {
      path: "/parseTest",
      name: "parseTest",
      component: parseTest
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js